// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"450f6e95","455":"260f181d","977":"db29e3d8"}[chunkId] + ".chunk.js";
};